import { render, staticRenderFns } from "./TrendBadge.vue?vue&type=template&id=19d0f941&scoped=true"
import script from "./TrendBadge.vue?vue&type=script&lang=js"
export * from "./TrendBadge.vue?vue&type=script&lang=js"
import style0 from "./TrendBadge.vue?vue&type=style&index=0&id=19d0f941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0f941",
  null
  
)

export default component.exports